export default "__VITE_ASSET__CffQJR87__"